import { render, staticRenderFns } from "./PainelProjetosSert.vue?vue&type=template&id=4849bba1"
import script from "./PainelProjetosSert.vue?vue&type=script&lang=js"
export * from "./PainelProjetosSert.vue?vue&type=script&lang=js"
import style0 from "./PainelProjetosSert.vue?vue&type=style&index=0&id=4849bba1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports